import React from "react";
import { Redirect, Route, Switch } from "polyrouter";
import { AccountRouter } from "./Accounts/AccountRouter";
import { FeatureFlagsOrEnabled } from "elements/FeatureFlag";
import ProfileRouter from "./Profile/ProfileView";
import { AppRoute } from "../AppRoute";
import AdvancedTools from "routes/Admin/AdvancedTools/AdvancedTools";
import { PolyUsersRouter } from "./PolyUsers/PolyUsersRouter";

let AdminRouter = () => (
  <Switch nest>
    <AppRoute path="/accounts" Component={AccountRouter} />
    <AppRoute path="/poly-users" Component={PolyUsersRouter} />
    <AppRoute path="/profile" Component={ProfileRouter} />
    <AppRoute
      path="/tools"
      Component={() => (
        <FeatureFlagsOrEnabled
          feature="SITE_TOPOLOGY_IMPORT"
          orFeature="IS_POLY_USER"
          elseRender={<AccountRouter />}
        >
          <AdvancedTools />
        </FeatureFlagsOrEnabled>
      )}
    />
    <Route nest path="/">
      <Redirect nest to="accounts" />
    </Route>
  </Switch>
);
export default AdminRouter;
